'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilityLabel = require('./components/VisibilityLabel.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilityLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-label/index.js
// module id = 1351
// module chunks = 0